import React from 'react';

export default function StubContainer(props) {
  return (
    <div>
      <button
        type="submit"
        data-cy="submitBanking"
        onClick={() => props.nextStep()}
      >
        Submit Banking
      </button>
    </div>
  );
}
